var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.29 4.04a.65.65 0 0 1 .92 0l3.5 3.5a.65.65 0 0 1 0 .92l-3.5 3.5a.65.65 0 0 1-.92-.92L9.33 8 6.29 4.96a.65.65 0 0 1 0-.92Z","fill":"currentColor"}));
}

ChevronRight.defaultProps = {"width":"16","height":"16","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
